// extracted by mini-css-extract-plugin
export default {"root":"HoverTooltip_root__oksml","tooltip":"HoverTooltip_tooltip__uftn8"};